import React from 'react';

import { makeStyles } from 'tss-react/mui';
import { FilterList } from '@mui/icons-material';
import { Button, ButtonProps, ClosableMenu } from '@uplift/ui-v2';

import { ClientsStatusFilterValue } from './ClientsStatusFilter.types';
import { ClientsStatusFilterItem } from './ClientsStatusFilterItem.component';

const useStyles = makeStyles()(theme => ({
  button: {},
  menuPaper: {
    marginTop: theme.spacing(0.5),
  }
}));


export type ClientsStatusFilterProps = {
  patients: Record<ClientsStatusFilterValue, unknown[]>;
  value: ClientsStatusFilterValue;
  setValue: (v: ClientsStatusFilterValue) => void;
  classes?: Partial<ReturnType<typeof useStyles>['classes']>;
  buttonSize?: ButtonProps['size'];
  disabled?: boolean;
};


export const ClientsStatusFilter: React.FC<ClientsStatusFilterProps> = ({ value, setValue, patients, classes: _classes, buttonSize, disabled }) => {
  const { classes } = useStyles(undefined, {
    props: {
      classes: _classes
    }
  });
  const [ anchorEl, setAnchorEl ] = React.useState<HTMLElement>();
  const options = React.useMemo(() => [
    {
      value: 'active' as const,
      label: `Active Clients (${patients?.active?.length ?? '0'})`,
    },
    {
      value: 'inactive' as const,
      label: `Inactive Clients (${patients?.inactive?.length ?? '0'})`,
    },
    {
      value: 'all' as const,
      label: `All Clients (${patients?.all?.length ?? '0'})`,
    },
  ], [ patients ]);
  const currentOption = React.useMemo(() => {
    return options.find(o => o.value === value);
  }, [ options, value ]);

  return (
    <>
      <Button
        className={classes.button}
        startIcon={<FilterList />}
        variant="outlined"
        color="secondary"
        onClick={e => setAnchorEl(e.currentTarget)}
        size={buttonSize}
        disabled={disabled}
      >
        {currentOption.label}
      </Button>
      <ClosableMenu
        PaperProps={{
          className: classes.menuPaper,
        }}
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        {options.map(o => (
          <ClientsStatusFilterItem
            key={o.value}
            label={o.label}
            value={o.value}
            selectedValue={value}
            setValue={setValue}
          />
        ))}
      </ClosableMenu>
    </>
  );
};
